import { DataBean } from "../DataBean";

export class AdquisitionItemProcess extends DataBean{

    public async requestContractItem(idAdquisitionItem:number,idEmployee:number,obs:string): Promise<any> {
        return this.getCustomService("SupplierERP", "com.orange.bean.AdquisitionItemProcess_requestContractItem_Number_Number_String", [idAdquisitionItem,idEmployee,obs]);
    }
    
}